import React, { forwardRef, useEffect, useState } from 'react';
import { Headphones, Camera, User, Compass } from 'lucide-react';

const ServicesSection = forwardRef((props, ref) => 
  {
  const ServiceIcon = ({ Icon }) => (
    <div className="flex items-center justify-center w-14 h-14 rounded-xl bg-[#FF800014]">
      <Icon className="w-8 h-8 text-orange-500" />
    </div>
  );

  const services = [
    {
      icon: <ServiceIcon Icon={Headphones} />,
      title: "Audio Production",
      description: (<>Commercial grade production,<br/> mix & master for any genre.</>)
    },
    {
      icon: <ServiceIcon Icon={Camera} />,
      title: "Video Production",
      description: (<>Concept to Delivery<br/> Music Video Creation.</>)
    },
    {
      icon: <ServiceIcon Icon={User} />,
      title: "Music Marketing",
      description: (<>YouTube Ads, Spotify Playlists<br/>& Instagram Content Marketing.</>)
    },
    {
      icon: <ServiceIcon Icon={Compass} />,
      title: "Community",
      subtitle: "(Coming Soon)",
      description: (<>India’s Largest community for<br/> artists.</>)
    }
  ];
 const [isWideScreen, setIsWideScreen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      
      setIsWideScreen(window.innerWidth > 1500);
    };

    // Set on initial render
    handleResize();

    // Listen to resize
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return (
    <div className="min-h-screen bg-black text-white py-16 md:scroll-mt-24" ref={ref}>
      <div className="">
        <h1 className="text-2xl lg:text-5xl font-normal text-center mb-10 font-inter">OUR SERVICES</h1>
        
        <div className={`grid lg:grid-cols-[60%_40%] items-center max-w-7xl md:justify-self-center mx-auto`}>
         
          <div className="space-y-12">
     
            <div className="hidden lg:grid lg:grid-cols-2 lg:gap-x-16 lg:gap-y-12">
              {services.map((service, index) => (
                <div key={index} className="space-y-4">
                  <div>
                    {service.icon}
                  </div>
                  <div>
                    <h3 className="text-[20px] md:text-[24px] font-normal mb-2">
                      {service.title}
                      {service.subtitle && (
                        <span className="text-orange-500 ml-2">{service.subtitle}</span>
                      )}
                    </h3>
                    <p className="text-[16px] md:text-[20px] text-[#989898] leading-relaxed font-normal">
                      {service.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            {/* Mobile Layout */}
            <div className="lg:hidden space-y-16 text-center">
              {services.map((service, index) => (
                <div key={index} className="space-y-4">
                  <div className="flex justify-center">
                    {service.icon}
                  </div>
                  <div>
                    <h3 className="text-[20px] md:text-[24px] font-medium mb-2">
                      {service.title}  {service.subtitle && (
                      <p className="text-orange-500  mb-2">{service.subtitle}</p>
                    )}
                    </h3>
                  
                    <p className="text-[#989898] text-[16px] md:text-[20px] leading-relaxed max-w-sm mx-auto">
                      {service.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

        
          <div className="relative hidden lg:block ">
            <div className="relative z-10 ">
              <img 
                src="https://rummy-assets.jungleerummy.com/Content/versioned/2.0.0.1/images/version4/promotion_june_25/zenrik_images/distribution-service-(1)-17512218287227.webp?v=1751221830"
                alt="Music Equipment"
                className="w-full h-auto"
              />
            </div>
            
           
          </div>
        </div>
      </div>
    </div>
  );
});

export default ServicesSection;